import type { BrandCode } from "core/entities";

const SubDomainMap = new Map<string, BrandCode>([
  ["portal-cre", "cre"],
  ["portal-fixauto", "fixaut"],
  ["portal-novusglass", "novusglass"],
  ["portal-procolor", "proc"],
  ["portal-speedy", "speedyauto"],
  ["portal-speedyauto", "speedyauto"],
  ["portal-speedyglass", "speedyglass"],
  ["portal-collisionrepairexperts", "cre"],
  ["portal-novuscrystalglass", "crystalglass"],
  ["portal-fixnationrestoration", "nationrestoration"],
]);

export default SubDomainMap;
